import classnames from 'classnames';
import { bool, string } from 'prop-types';
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import './MainTooltip.scss';

const MainTooltip = props => {
  const {
    warning,
    info,
    message,
    className,
    innerClassName,
    target,
    ...otherProps
  } = props;
  return (
    <>
      <i
        className={classnames(' main-tooltip__icon', className, {
          'fa fa-exclamation-circle main-tooltip__icon--warning': warning,
          'fa fa fa-info-circle main-tooltip__icon--info': info,
        })}
        aria-hidden="true"
        id={target}
      />
      <UncontrolledTooltip
        className={classnames('main-tooltip__uncontrolled-tooltip', className)}
        innerClassName={classnames(
          'main-tooltip__inner-tooltip',
          innerClassName,
          {
            'main-tooltip__inner-tooltip--warning': warning,
            'main-tooltip__inner-tooltip--info': info,
          },
        )}
        target={target}
        {...otherProps}
      >
        {message}
      </UncontrolledTooltip>
    </>
  );
};

MainTooltip.propTypes = {
  innerClassName: string,
  message: string,
  className: string,
  warning: bool,
  info: bool,
  target: string.isRequired,
};

MainTooltip.defaultProps = {
  innerClassName: '',
  className: '',
  message: '',
  warning: false,
  info: false,
};

export default MainTooltip;
